import { render, staticRenderFns } from "./Step2Part4.vue?vue&type=template&id=3772fc6c&"
import script from "./Step2Part4.vue?vue&type=script&lang=js&"
export * from "./Step2Part4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports